// Request Limit Service
// Lowering max requests per attendee after requests start goes through a callable that checks the live floor (ITER-142)

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export interface SetRequestLimitResult {
  maxRequestsPerUser: number;
  floor: number;
}

export async function setRequestLimit(eventId: string, maxRequestsPerUser: number): Promise<SetRequestLimitResult> {
  const callable = httpsCallable<{ eventId: string; maxRequestsPerUser: number }, SetRequestLimitResult>(functions, 'setRequestLimit');
  const result = await callable({ eventId, maxRequestsPerUser });
  return result.data;
}

export function requestLimitRefusalFloor(err: unknown): number | null {
  if (typeof err !== 'object' || err === null) return null;
  const { code, details } = err as { code?: unknown; details?: unknown };
  if (code !== 'functions/failed-precondition') return null;
  const floor = (details as { floor?: unknown } | null | undefined)?.floor;
  return typeof floor === 'number' ? floor : null;
}
